export const SET_EVENTS_CONTENT = 'SET_EVENTS_CONTENT';
